import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { pages } from '@/settings/pages';
import { FLASH_MESSAGE_LIFETIME_MILLISEC } from '@/constants';

export const ActivationAlreadyActivated: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.activation.alreadyActivated.title');

  setTimeout(() => {
    window.location.assign(pages.top);
  }, FLASH_MESSAGE_LIFETIME_MILLISEC);

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    ></PageRootWrapper>
  );
};
